<template>
    <div class="content_singledishmeal">
        <TypeALaCarte  v-if="typeMenu == 'alacarte'"/>
        <TypeDrink  v-if="typeMenu == 'drink'"/>
    </div>
</template>

<script>
import TypeALaCarte from '@/components/menuuser/menutype/TypeALaCarte.vue'
import TypeDrink from '@/components/menuuser/menutype/TypeDrink.vue'
export default {
    props:['typeMenu'],
    components:{
        TypeALaCarte,
        TypeDrink,
    },
}
</script>

<style scoped>
.content_singledishmeal {
    padding-top: 130px;
    padding-bottom: 100px;
}
</style>